import Image from "next/image";
import WidthWrapper from "./width-wrapper";
import Link from "next/link";
import { Globe } from "lucide-react";

export default function Footer({ store }: { store?: string }) {
  return (
    <footer>
      <WidthWrapper className="bg-[#FFFFFFCC] p-6 lg:py-6   xl:pb-0 !px-0">
        <div className="flex flex-col gap-0">
          <div className="flex flex-col md:flex-row justify-between items-top max-w-[1134px] w-full mx-auto px-6  ">
            <div className="flex flex-col items-center md:items-start ">
              <p className="font-semibold font-mt leading-[32px] tracking-[-1%] sm:text-lg text-base md:text-left mb-4">
                Start Using RapidStock Today
              </p>
              <Link
                href="https://bstgroup.com.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src="/bstgroup.svg"
                  width={74}
                  height={34}
                  alt="BST Group"
                />
              </Link>
              <br />
              <div className="flex space-x-8 space-y-8  flex-wrap ">
                <Link
                  href={`/download?store=${store}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src="/apple-store.svg"
                    alt="Download on the App Store"
                    width={191}
                    height={40}
                    className="h-12 w-auto"
                  />
                </Link>
                <Link
                  href={`/download?store=${store}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src="/google-play.png"
                    alt="Get it on Google Play"
                    width={191}
                    height={40}
                    className="h-12 w-auto"
                  />
                </Link>
                <Link
                  href="https://bstgroup.rapidstock.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black rounded-lg py-2 px-3 flex h-[48px] [&_svg]:size-7 gap-2 items-center text-white w-[158px]"
                >
                  <Globe />
                  <div className="flex flex-col">
                    <p className="text-white text-[13px]">View </p>
                    <p className="text-white font-semibold text-[17px] -mt-[3px]">
                      Web App
                    </p>
                  </div>
                </Link>
              </div>
              <div className="flex md:hidden w-full flex-col gap-3 justify-start items-start mt-5"></div>
            </div>
          </div>
          <div className="w-full border-t border-gray-200 sm:block hidden ">
            <div className="max-w-[1134px] mx-auto flex flex-row justify-between items-center gap-[28px] lg:pt-6 pt-4 lg:pb-4 px-6 ">
              <p className="text-gray-500 sm:text-sm text-[13px] text-center md:text-left">
                Copyright © {new Date().getFullYear()} BST Group Pty Ltd
              </p>
              <div className="flex items-center gap-[28px] sm:text-sm text-xs leading-[20px] font-medium font-mt">
                {process.env.PRIVACY_POLICY && (
                  <Link
                    href={process.env.PRIVACY_POLICY || ""}
                    className="text-gray-500"
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>
                )}
                {process.env.TERMS_OF_USE && (
                  <Link
                    href={process.env.TERMS_OF_USE || ""}
                    target="_blank"
                    className="text-gray-500"
                  >
                    Terms & Conditions
                  </Link>
                )}

                <Link href="/support" className="text-gray-500" target="_blank">
                  Support
                </Link>
              </div>
            </div>
          </div>
        </div>
      </WidthWrapper>
    </footer>
  );
}
